// extracted by mini-css-extract-plugin
export default {"formWrapper":"Registerpage_formWrapper__nnH+t","title":"Registerpage_title__lckr6"};